// Copyright (c) Bentley Systems
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  clearIsToastError,
  selectIsToastError,
} from "./app/is-toast-error-slice";
import { clearIsError, ErrorState, selectIsError } from "./app/is-error-slice";
import {
  MESSAGES,
  STATUS,
  useToastNotificationService,
} from "./Helpers/ToastNotificationService";

const Toaster = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isToastErrorState = useAppSelector(selectIsToastError);
  const isErrorState = useAppSelector(selectIsError);

  const { showToast } = useToastNotificationService();
  useEffect(() => {
    if (isErrorState.silent) {
      let status: string = "";
      let message: string = "";
      switch (isErrorState.errorState) {
        case ErrorState.Forbidden:
        case ErrorState.Unauthorized:
          status = STATUS.WARNING;
          message = MESSAGES.UNAUTHORIZED;
          break;
        case ErrorState.NotFound:
          status = STATUS.WARNING;
          message = MESSAGES.NOT_FOUND;
          break;
        default:
          status = status !== "" ? status : STATUS.NEGATIVE;
          message = MESSAGES.NEGATIVE_DEFAULT;
          break;
      }
      message =
        isToastErrorState.message !== "" ? isToastErrorState.message : message;
      if (status === STATUS.NEGATIVE) {
        message = `${message  } [ActivityId="${isErrorState.activityId}"]`;
      }
      showToast({
        action: isToastErrorState.action,
        status,
        message,
      });
      dispatch(clearIsToastError());
      dispatch(clearIsError());
    }
  }, [isToastErrorState, isErrorState.activityId, showToast]);

  useEffect(() => {
    if (
      isErrorState.errorState !== ErrorState.NoError &&
      !isErrorState.silent
    ) {
      const navigateUrl = `errorPage${  window.location.search}`;
      void navigate(navigateUrl);
    }
  }, [isErrorState.errorState, isErrorState.activityId]);

  return <div />;
};

export default Toaster;
